var _defs, _path, _path2, _line, _line2, _line3, _polyline, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "office-stamp-document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.75,6V1.727A.975.975,0,0,1,7.721.748h9.7l5.824,5.87V22.27a.975.975,0,0,1-.971.978H15.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.25.748v5a1,1,0,0,0,1,1h5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.804,
    y1: 10.498,
    x2: 12.75,
    y2: 10.498
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.804,
    y1: 19.498,
    x2: 18,
    y2: 19.498
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 20.804,
    y1: 14.998,
    x2: 14.25,
    y2: 14.998
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "0.75 20.248 1.5 23.248 12 23.248 12.75 20.248"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.75,17.248H8.25V14.582a3,3,0,1,0-3,0v2.666H3.75a3,3,0,0,0-3,3h12A3,3,0,0,0,9.75,17.248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDoc);
export default __webpack_public_path__ + "static/media/action-doc.38af7e9e032a7f1a786895c6d962b4df.svg";
export { ForwardRef as ReactComponent };